import React from 'react';
import CareReferralCatalogManager from '../careReferrals/CareReferralCatalogManager';

export default function HeadDoctorCareReferralsPage() {
  return <CareReferralCatalogManager />;
}
